import * as signalR from "@microsoft/signalr";

const API_BASE_URL = ((import.meta.env.VITE_API_BASE_URL as string) || "").replace(/\/api$/, '');

export interface SignalRConnection {
  connection: signalR.HubConnection;
  start: () => Promise<void>;
  stop: () => Promise<void>;
}

export function createApplicationHubConnection(
  organizationId: string
): SignalRConnection {
  const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${API_BASE_URL}/hubs/application?organizationId=${organizationId}`, {
      withCredentials: true,
      transport: signalR.HttpTransportType.WebSockets,
    })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();

  const start = async () => {
    try {
      await connection.start();
      console.log("SignalR Connected to Application Hub");
    } catch (err) {
      console.error("SignalR Connection Error:", err);
      setTimeout(start, 5000);
    }
  };

  const stop = async () => {
    try {
      await connection.stop();
      console.log("SignalR Disconnected from Application Hub");
    } catch (err) {
      console.error("SignalR Disconnect Error:", err);
    }
  };

  return { connection, start, stop };
}

const _hubConnections = new Map<string, SignalRConnection>();

export function getOrCreateApplicationHubConnection(
  organizationId: string
): SignalRConnection {
  const existing = _hubConnections.get(organizationId);
  if (existing) {
    return existing;
  }
  const conn = createApplicationHubConnection(organizationId);
  _hubConnections.set(organizationId, conn);
  return conn;
}

export function clearAllHubConnections(): void {
  _hubConnections.forEach((conn) => {
    conn.stop();
  });
  _hubConnections.clear();
}
